import styled from 'styled-components';

export const Wrapper = styled.div`
	width: 100%;
	.ag-theme-balham {
		.ag-header-cell {
			text-align: center;
		}
		.ag-header-row {
			.ag-header-cell {
				.ag-cell-label-container {
					justify-content: center;

					.ag-header-cell-label {
						flex: unset;
					}
				}
			}
		}
		.ag-row {
			.ag-cell {
				text-align: center;
			}
		}
	}
`;
